import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  otpData: {},
};

const authOtpSlice = createSlice({
  name: "authotp",
  initialState: initialState,
  reducers: {
    setOtpData: (state, action) => {
      state.otpData = action.payload;
    },
  },
});

export const { setOtpData } = authOtpSlice.actions;
export default authOtpSlice.reducer;
